export default {
  xreports: {
    appId: "Basic eG06eG1fc2VjcmV0"
  },
  hotelcem: {
    appId: "Basic Y2VtX212cDpjZW1fbXZwX3NlY3JldA=="
  },
  survey: {
    appId: "Basic c2FiZXI6c2FiZXJfc2VjcmV0"
  },
  qms: {
    appId: "Basic cW1zOnFtc19zZWNyZXQ="
  },
  boss: {
    appId: "Basic Ym9zczpib3NzX3NlY3JldA=="
  },
  jms: {
    appId: "Basic am1zOmptc19zZWNyZXQ="
  },
  cms: {
    appId: "Basic Y21zOmNtc19zZWNyZXQ="
  },
  rms: {
    appId: "Basic cm1zOnJtc19zZWNyZXQ="
  }
}
